import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Typography } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { ConfirmDialog } from '@sierralabs/core-ui';
import ConfigCard from './config/components/ConfigCard';
import ConfigContent from './config/components/ConfigContent';
import FormConfigActions from './config/FormConfigActions';
import FormConfigDataSource from './config/FormConfigDataSource';
import FormConfigElement from './config/FormConfigElement';
import FormConfigEventList from './config/FormConfigEventList';
import FormConfigLayout from './config/FormConfigLayout';
import FormConfigSection from './config/FormConfigSection';
import { useFormContext } from './FormContext';
const StyledDiv = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .config-header {
  }
  .config-body {
    padding: 12px 24px;
  }
  .config-zero-state {
    padding: 12px;
    text-align: center;
    color: #999;
  }
  .btn-delete {
    color: #f47560;
    border-color: #f47560;
  }
`;
export const FormConfigure = () => {
    var _a, _b;
    const { formState, formSections, deleteElement, deleteSection, elementPlugins } = useFormContext();
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const element = formState.selectedFormElement;
    const sectionStateNode = formState.selectedStateNode;
    const canDeleteSection = Boolean(formSections && formSections.length > 1);
    const canDeleteElement = Boolean(((_a = sectionStateNode === null || sectionStateNode === void 0 ? void 0 : sectionStateNode.meta) === null || _a === void 0 ? void 0 : _a.elements) &&
        sectionStateNode.meta.elements.length > 1);
    const plugin = elementPlugins.find(p => p.type === (element === null || element === void 0 ? void 0 : element.type));
    // handle not showing of Data Source Picker when
    // element type is Html and it is configured to be not editable
    const showDataSourceConfig = Boolean((element === null || element === void 0 ? void 0 : element.type) === 'Html'
        ? (plugin === null || plugin === void 0 ? void 0 : plugin.dataTypes) && element.config.editable
        : plugin === null || plugin === void 0 ? void 0 : plugin.dataTypes);
    return (React.createElement(StyledDiv, { className: 'form-configure' }, element ? (React.createElement(React.Fragment, null,
        React.createElement(FormConfigElement, null),
        showDataSourceConfig && React.createElement(FormConfigDataSource, null),
        React.createElement(FormConfigActions, { element: true }),
        React.createElement(FormConfigLayout, null),
        React.createElement(ConfigCard, null,
            React.createElement(ConfigContent, null,
                React.createElement(Button, { fullWidth: true, variant: 'outlined', endIcon: React.createElement(DeleteIcon, null), disabled: !canDeleteElement, className: canDeleteElement ? 'btn-delete' : undefined, onClick: () => setOpenDeleteDialog(true) }, "Delete Form Element"))),
        React.createElement(ConfirmDialog, { open: openDeleteDialog, title: 'Delete Form Element', message: 'Are you sure you want to remove this element? This action cannot be undone.', onCancel: () => setOpenDeleteDialog(false), onConfirm: () => {
                setOpenDeleteDialog(false);
                deleteElement();
            } }))) : sectionStateNode ? (React.createElement(React.Fragment, null,
        React.createElement(FormConfigSection, null),
        React.createElement(FormConfigEventList, null),
        React.createElement(FormConfigActions, { section: true }),
        React.createElement(ConfigContent, null,
            React.createElement(Button, { fullWidth: true, variant: 'outlined', endIcon: React.createElement(DeleteIcon, null), disabled: !canDeleteSection, className: canDeleteSection ? 'btn-delete' : undefined, onClick: () => setOpenDeleteDialog(true) }, "Delete Section")),
        openDeleteDialog && (React.createElement(ConfirmDialog, { open: openDeleteDialog, title: 'Delete Section', message: `Are you sure you want to remove the section "${((_b = sectionStateNode.meta) === null || _b === void 0 ? void 0 : _b.title) || ''}" and all of its content? This action cannot be undone.`, onCancel: () => setOpenDeleteDialog(false), onConfirm: () => {
                setOpenDeleteDialog(false);
                if (!formSections) {
                    return;
                }
                const index = sectionStateNode
                    ? formSections.indexOf(sectionStateNode)
                    : -1;
                if (index > -1) {
                    deleteSection(index);
                }
            } })))) : (React.createElement("div", { className: 'config-zero-state' },
        React.createElement(Typography, { variant: 'overline' }, "Select a form element to edit")))));
};
export default FormConfigure;
//# sourceMappingURL=FormConfigure.js.map